<template>
  <FC2
    v-bind="$props"
    :id="id"
    :label="label"
    :fcType="'fc2-datepicker'"
    :height="height"
    :textarea="textarea"
    :bb="bb"
    :valued="valued"
  >
    <v-menu
      :disabled="disabled"
      :close-on-content-click="false"
      v-model="menuFlag"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <div
        class="date-control"
        :class="{
          hover0: hoverStyle == 0,
        }"
        :style="{
          display: 'flex',
          wdith: '100%',
        }"
        slot="activator"
      >
        <div
          :class="`date-value txtov ${disabled ? 'disabled' : ''}`"
          :style="{
            marginRight: '10px',
          }"
        >
          <span v-if="toDateString">{{ toDateString }}</span>
          <span v-else class="date-placeholder">{{
            placeholder || datePlaceholder
          }}</span>
        </div>
        <div class="dt-icon-container">
          <img src="static/icons/calendar-lg.svg" class="dt-icon v5 s0" alt />
        </div>
      </div>
      <div class="date-picker-menu">
        <v-date-picker
          :value="toDate"
          @input="onDatePickerInput"
        ></v-date-picker>
        <button
          v-if="canReset"
          class="dt-button s3"
          style="margin: 4px auto"
          @click="onClearDateClick"
        >
          Clear Date
        </button>
      </div>
    </v-menu>
  </FC2>
</template>

<script>
import { toSnakeCase, uuidv4 } from "../../utility";
import FC2, { FC2PropTypes } from "../fc2/fc2";
import { FC2Mixin } from "../fc2";
import { format } from "date-fns";

const INPUT_HEIGHT = 32;
const TEXTAREA_HEIGHT = 80;

export default {
  components: {
    FC2,
  },
  props: {
    canReset: {
      type: Boolean,
      default: true,
    },
    ...FC2PropTypes,
    hoverStyle: {
      type: Number,
      default: 0,
    },
  },
  mixins: [FC2Mixin()],
  mounted: function () {},
  computed: {
    toDate: function () {
      return format(this.value || new Date(), "YYYY-MM-DD");
    },
    toDateString: function () {
      return this.value ? format(this.value, "YYYY-MM-DD") : "";
    },
  },
  data: function () {
    return {
      _id: uuidv4(),
      menuFlag: null,
      datePlaceholder: "_ _ _ _-_ _-_ _",
    };
  },
  methods: {
    onDatePickerInput: function (value) {
      this.menuFlag = false;
      this.emit("input", value, []);
    },
    onClearDateClick() {
      this.menuFlag = false;
      this.emit("input", "", []);

      console.log({ onClearDateClick: 23 });
    },
  },
};
</script>
<style lang="scss">
.fc2-datepicker {
  .menu {
    width: 100%;
    min-width: 0px;
    /* background: white !important; */

    .menu__activator {
      // height: 100%;
      .date-control {
        // height: 100%;

        margin: var(--fc2-cm);
        padding: 1px 2px 1px 10px;

        background-color: var(--fc2-bc);
        color: var(--text-primary);
        
        .date-placeholder {
          color: var(--text-5);
        }

        border: 1px solid;
        border-color: var(--fc2-bdc);
        border-radius: 4px;

        &.hover0 {
          &:hover {
            --fc2-bdc: var(--bc-cblue5);
            --fc2-bc: var(--bc-cblue);
          }
        }

        .date-value {
          flex: var(--fc2-cf);

          display: flex;
          flex-direction: column;
          justify-content: center;

          .date-placeholder {
            // opacity: 0.25;
          }

          &.disabled {
            // opacity: 0.5;
          }
        }
      }
    }
  }

  &.invalid {
    background: var(--bc-accent-a1);
  }

  &.shrink-margin {
    .dropdown--main__text {
      // color: var(--text-5) !important;
    }
    .date-control {
      padding-left: 0px !important;
      padding-right: 0px !important;
      width: 100%;

      .date-value.txtov  {
        margin-right: 0px !important;
      }
    }
  }
}

.date-picker-menu {
  background: white;
  .picker.picker--date.card {
    box-shadow: none !important;
  }
}
</style>